import { EUserType } from '../types'

export function isAdminOrSuper(userRoleType?: keyof typeof EUserType) {
  return userRoleType === EUserType.Admin || userRoleType === EUserType.Super
}
